export const onlyDigits = value => String(value ?? '').replace(/\D/g, '')

export const onlyAlphaNumeric = value => String(value ?? '').replace(/[^a-zA-Z0-9]/g, '')

export const isFilled = value => String(value ?? '').trim().length > 0

export const validEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? '').trim())

export const validFullName = value => {
  const words = String(value ?? '')
    .trim()
    .split(/\s+/)
    .filter(word => word.length >= 2)

  return words.length >= 2
}

export const validCpf = value => {
  const cpf = onlyDigits(value)

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false

  const calculateDigit = factor => {
    let total = 0

    for (let index = 0; index < factor - 1; index += 1) {
      total += Number(cpf[index]) * (factor - index)
    }

    const rest = (total * 10) % 11
    return rest === 10 ? 0 : rest
  }

  return calculateDigit(10) === Number(cpf[9]) &&
    calculateDigit(11) === Number(cpf[10])
}

export const validRg = value => onlyAlphaNumeric(value).length === 9

export const validBirthDate = value => {
  const digits = onlyDigits(value)

  if (digits.length !== 8) return false

  const day = Number(digits.slice(0, 2))
  const month = Number(digits.slice(2, 4))
  const year = Number(digits.slice(4, 8))
  const date = new Date(year, month - 1, day)
  const today = new Date()

  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date <= today &&
    year >= 1900
}

export function useFormValidation() {
  return {
    onlyDigits,
    onlyAlphaNumeric,
    isFilled,
    validEmail,
    validFullName,
    validCpf,
    validRg,
    validBirthDate,
  }
}
